import { Button } from "@/components/ui/shadcn/Button/Button";
import { Card } from "@/components/ui/shadcn/Card/Card";
import { useSidebar } from "@/components/ui/shadcn/Sidebar/Sidebar";
import { cn } from "@/lib/utils/cn";
import { SidebarIcon } from "lucide-react";
import type { ReactNode } from "react";

type AppPageShellProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  cardClassName?: string;
  padding?: "default" | "none";
  showMobileSidebarToggle?: boolean;
  surface?: "plain" | "card";
};

export function AppPageShell({
  children,
  className,
  contentClassName,
  cardClassName,
  padding = "default",
  showMobileSidebarToggle = true,
  surface = "plain",
}: AppPageShellProps) {
  const { toggleSidebar } = useSidebar();

  return (
    <div
      className={cn(
        /* min-h-0: avoid `min-h-screen` forcing 100vh inside `_auth` main (below top bar, within `h-svh`) */
        "relative flex min-h-0 w-full min-w-0 flex-1 flex-col",
        padding === "default" && "p-4 sm:p-6",
        className,
      )}
    >
      {showMobileSidebarToggle ? (
        <div className="fixed top-4 left-4 z-50 md:hidden">
          <Button
            size="icon"
            variant="outline"
            className="shadow-md"
            onClick={toggleSidebar}
            aria-label="Open app sidebar"
          >
            <SidebarIcon className="h-4 w-4" />
          </Button>
        </div>
      ) : null}

      {surface === "card" ? (
        <Card
          className={cn(
            "flex min-h-0 w-full flex-1 flex-col overflow-hidden",
            cardClassName,
          )}
        >
          <div className={cn("flex min-h-0 flex-1 flex-col", contentClassName)}>
            {children}
          </div>
        </Card>
      ) : (
        children
      )}
    </div>
  );
}
